import { Pipe, PipeTransform } from '@angular/core';
import { isNil } from 'lodash-es';

@Pipe({
	name: 'enumToArray',
	standalone: false,
})
export class EnumToArrayPipe implements PipeTransform {
	transform(enumData: object) {
		if (!isNil(enumData)) {
			return Object.keys(enumData);
		}
		return null;
	}
}
